export default JSON.parse(process.env.REACT_APP_LOCALES_FORMAT_JS);
